import React from "react";
import { Input } from "reactstrap";

const WrappedInput = React.forwardRef((props, ref) => (
  <Input innerRef={ref} {...props} />
));

export default WrappedInput;
